import React, {useEffect} from 'react';
import { BrowserRouter } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { AppRoutes } from './AppRoutes';
import { theme } from './theme'; // Import our custom theme
import './global.css'; // Import global CSS for mobile responsiveness
import { AnalysisOptInProvider } from './components/modals/AnalysisOptInProvider';

// Extend Console interface to allow our custom properties
declare global {
    interface Console {
        originalLog?: typeof console.log;
        originalError?: typeof console.error;
    }
}

// Suppress all console logs
if (process.env.NODE_ENV === 'production') {
    // Save original console methods
    const originalConsole = {
        log: console.log,
        info: console.info,
        warn: console.warn,
        error: console.error,
        debug: console.debug
    };

    // Override console methods with empty functions
    console.log = () => {};
    console.info = () => {};
    console.warn = () => {};
    console.error = () => {};
    console.debug = () => {};
    
    // Optionally, you can keep a way to use the original console in production if needed
    console.originalLog = originalConsole.log;
    console.originalError = originalConsole.error;
}

// Extend Console interface to allow our custom properties
declare global {
    interface Console {
        originalLog?: typeof console.log;
        originalError?: typeof console.error;
    }
}

// Suppress all console logs
if (process.env.NODE_ENV === 'production') {
    // Save original console methods
    const originalConsole = {
        log: console.log,
        info: console.info,
        warn: console.warn,
        error: console.error,
        debug: console.debug
    };

    // Override console methods with empty functions
    console.log = () => {};
    console.info = () => {};
    console.warn = () => {};
    console.error = () => {};
    console.debug = () => {};
    
    // Optionally, you can keep a way to use the original console in production if needed
    console.originalLog = originalConsole.log;
    console.originalError = originalConsole.error;
}

// todo: implement back button! this is obviously not going to cut it...
export const useBackButton = (callback: () => void) => {
    useEffect(() => {
        window.history.pushState(null, '', window.location.pathname);
        window.addEventListener('popstate', callback);
        return () => {
            window.removeEventListener('popstate', callback);
        };
    }, [callback]);
};



export default function App() {
    return (
        <MantineProvider theme={theme}>
            <BrowserRouter>
                <AnalysisOptInProvider>
                    <AppRoutes />
                </AnalysisOptInProvider>
            </BrowserRouter>
        </MantineProvider>
    );
}
